<script lang="ts">
  import css from '../../../../css/comments.pcss.json'
  import type { CommentAttachment } from "../../comments/CommentTypes";
  import SGPlugins from "../../../common/SGPlugins";
  import Attachment from "./Attachment.svelte";
  import LinkAttachment from "./LinkAttachment.svelte";
  import GameAttachment from "./GameAttachment.svelte";
  import cn from "classnames";

  export let attachments: Array<CommentAttachment>
  export let commentId: number

  let sectionRef: HTMLElement

  $: attachments = attachments.map(attachment => {
    const previewUrl = attachment.preview_url
    if (previewUrl) {
      const matches = previewUrl.matchAll(/\/\//g)
      if (matches) {
        const realMatches = [...matches]
        if (realMatches.length > 1) {
          return {
            ...attachment,
            preview_url: previewUrl.substring(previewUrl.indexOf('//', 7))
          }
        }
      }
    }
    return attachment
  })

  $: linkAttachments = attachments.filter(attachment => ['link', 'website'].includes(attachment.type))
  $: mediaAttachments = attachments.filter(attachment => ['image', 'video'].includes(attachment.type))
  $: gameAttachments = attachments.filter(attachment => attachment.type === 'game')
  $: onlyOneLink = linkAttachments.length === 1
  $: onlyOneMedia = mediaAttachments.length === 1
  $: onlyOneGame = gameAttachments.length === 1

  $: {
    if (sectionRef) {
      SGPlugins.callPlugin('sg-lightbox', sectionRef)
    }
  }
</script>

{#if linkAttachments.length > 0}
  <section
    class={css['comment__attachments']}
  >
    {#each linkAttachments as attachment, key (`${commentId}-link-attachment-${attachment.UUID}-${key}`)}
      <LinkAttachment attachment={attachment} onlyAttachment={onlyOneLink}/>
    {/each}
  </section>
{/if}
{#if mediaAttachments.length > 0}
  <section
    bind:this={sectionRef}
    class={cn({
      [css['comment__attachments']]: true,
      [css['comment__attachments--images']]: true
    })}
    data-plugins="lightbox"
    data-lightbox-rel={`comment-${commentId}`}
  >
    {#each mediaAttachments as attachment, key (`${commentId}-media-attachment-${attachment.UUID}-${key}`)}
      <Attachment attachment={attachment} onlyAttachment={onlyOneMedia}/>
    {/each}
  </section>
{/if}
{#if gameAttachments.length > 0}
  <section
    class={cn({
      [css['comment__attachments']]: true,
      [css['comment__attachments--games']]: true
    })}
  >
    {#each gameAttachments as attachment, key (`${commentId}-game-attachment-${attachment.UUID}-${key}`)}
      <GameAttachment attachment={attachment} onlyAttachment={onlyOneGame}/>
    {/each}
  </section>
{/if}

